<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top> {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <ClientNav class="hideOnPrint"/>
        <v-row dense class="hideOnPrint">
            <v-col cols="12" lg="3" xl="2">
                <ClientSide/>
            </v-col>
            <v-col cols="12" lg="9" xl="10">
                <v-card class="pa-2" outlined tile height="100%">
                    <v-data-table
                        :headers="headers"
                        :items="weeklySummaries"
                        sort-by="ReportDate"
                        sort-desc
                        :loading="isLoading"
                        loading-text="Loading Weekly Summaries"
                        :search="search"
                        height="550"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Weekly Summaries</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-text-field
                                    v-model="search"
                                    clearable
                                    flat
                                    solo-inverted
                                    hide-details
                                    prepend-inner-icon="search"
                                    label="search"
                                    class="desktop"
                                ></v-text-field>
                                <v-spacer></v-spacer>
                                <v-btn
                                    fab
                                    small
                                    @click="printTable()"
                                    class="mr-8 mb-2 white--text"
                                    color="#2b6993"
                                    elevation="4"
                                >
                                    <v-icon>print</v-icon>
                                </v-btn>
                                <v-btn v-if="!isAuditorRole" color="#2b3990" dark class="mb-2" @click="showAdd()">
                                    <v-icon left>add</v-icon>
                                    Add Summary
                                </v-btn>
                            </v-toolbar>
                            <v-text-field
                                v-model="search"
                                clearable
                                flat
                                solo-inverted
                                hide-details
                                prepend-inner-icon="search"
                                label="search"
                                class="mobile ml-5 mr-5 mb-3 mt-3"
                            ></v-text-field>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-icon small class="mr-2" @click="viewWeeklySummary(item)">
                                mdi-eye
                            </v-icon>

                            <v-icon v-if="!isAuditorRole" small @click="deleteWeeklySummary(item)">
                                mdi-delete
                            </v-icon>

                        </template>
                        <template v-slot:no-data>
                            <v-btn color="#2b3990" class="white--text" @click="getWeeklySummaries()">Reset</v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <Foot class="hideOnPrint"/>

        <div id="printTable">
            <h2 class="text-center ma-3">Weekly Summary</h2>
            <v-row>
                <v-col cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="weeklySummaries"
                        sort-by="ReportDate"
                        sort-desc
                        :loading="isLoading"
                        loading-text="Loading Weekly Summaries"
                        :search="search"
                        hide-default-footer
                        disable-pagination
                        height="auto"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Weekly Summaries</v-toolbar-title>
                            </v-toolbar>

                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '../../components/ClientNav'
import ClientSide from '../../components/ClientSide'
import Foot from '../../components/Footer'

const url = require("../../client_config/config").url;

export default {
    components: {
        ClientNav,
        ClientSide,
        Foot,
    },
    data: function () {
        return {
            headers: [
                {
                    text: 'Report Date',
                    align: 'start',
                    value: 'ReportDate',
                },
                {text: "Summary", value: "Summary"},
                {text: "Manager Signature", value: "ManagerSignature"},
                {text: "Supervisor Signature", value: "SupervisorSignature"},
                {text: "Submitted", value: "Submitted"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            msg: false,
            search: "",
            text: "",
            weeklySummaries: [],
            units: [],
            codes: [],
            tempData: [],
            users: [],
            staff: "",
            unitID: localStorage.getItem('unitID'),
            clientID: this.$route.params.clientID,
            userID: localStorage.getItem('userID'),
            titleForm: "New Weekly Summary",
            summaryID: "",
            newStartDate: "",
            // newEndDate: "",
            newReportDate: "",
            newPlanDate: "",
            newSummary: "",
            newManagerSignature: "",
            newSupervisorSignature: "",
            newClientServSig: "",
            newSubmitted: "",
            newProviders: "",
            newGuardian: "",
            providers: [],
            isLoading: true,
        };
    },

    computed: {
        isAuditorRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        }
    },

    watch: {},

    created() {
        this.getWeeklySummaries();
        this.getUsers();
        this.getProviders();
    },

    methods: {
        initialize() {
            this.weeklySummaries = [];
        },

        viewWeeklySummary(item) {
            this.$router.push({
                path: `/weeklySummary/${this.clientID}/update/${item._id}`,
                query: {
                    updateSummary: true,
                },
            });
        },

        showAdd() {
            this.$router.push({
                path: `/weeklySummary/${this.clientID}/new`,
                query: {
                    createSummary: true,
                },
            });
        },

        deleteWeeklySummary(item) {
            const id = item._id;
            confirm("Are you sure you want to delete this weekly summary?") &&
            this.weeklySummaryDelete(id);

        },

        weeklySummaryDelete(id) {
            axios.delete(`${url}/weeklySummary/${id}`)
                .then((response) => {
                    this.getWeeklySummaries();
                    if (response.status === 400) {
                        response.json().then(function (data) {
                            return data.msg;
                        });
                    }
                    this.msg = true;
                    this.text = "The weekly summary has been deleted successfully.";
                });
        },

        getWeeklySummaries: function () {
            this.isLoading = true;
            axios.get(`${url}/weeklySummary/client/${this.clientID}`).then(res => {
                this.weeklySummaries = res.data.summaries
            }).finally(() => this.isLoading = false);
        },


        getUsers() {
            axios.get(`${url}/users`).then(async res => {
                this.users = res.data.users;
                for (var i = 0; i < this.users.length; i++) {
                    if (this.userID === this.users[i]._id) {
                        this.staff = this.users[i].Name
                    }
                }
            });
        },


        getProviders() {
            this.isLoading = true;
            axios.get(`${url}/providers`).then(res => {
                this.providers = [],
                    this.tempData = res.data.providers;
                for (var i = 0; i < this.tempData.length; i++) {
                    if (this.tempData[i].ClientID === this.clientID) {
                        this.providers.push(this.tempData[i])
                    }
                }
            }).finally(() => this.isLoading = false);
        },

        printTable() {
            document.getElementById('printTable').style.display = "block";
            window.print()
            document.getElementById('printTable').style.display = "none";
        },


    },

};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

#printTable {
    display: none;
}

#printItem {
    display: none;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

@media print {
    #printTable {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;

    }

    #printItem {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;


    }

    .hideOnPrint {
        display: none;
        border: none;
    }

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
        display: none;
        border: none;

    }

    @page {
        margin: 0;
    }

    body {
        margin: 1.6cm;
    }


}
</style>
